import clsx from "classnames";
import { Button, Container, Stack } from "react-bootstrap";
import { Carousel } from "@/components/Carousel";
import { JobCard } from "@/components/JobCard";
import { DynamicText } from "@/components/DynamicText";
import { useMediaQuery } from "@react-hook/media-query";
import { useEffect, useState } from "react";
import { useJobs } from "@/hooks/useJobs";
import { getRoute } from "@/routes";
import classes from "./styles.module.scss";
import blobx from "./Blobx.png";

export const JobsCarousel = ({ className, title = "Latest Jobs", limit = 16 }) => {
  const [visibleCount, setVisibleCount] = useState(1);
  const lg = useMediaQuery("only screen and (min-width: 992px)");
  const md = useMediaQuery("only screen and (min-width: 768px)");
  const jobs = useJobs({ limit });

  useEffect(() => {
    setVisibleCount(lg ? 4 : md ? 3 : 1);
  }, [lg, md]);

  return (
    <div className={clsx(className, classes.jobs)}>
      <img className={classes.jobs__blob} src={blobx} alt="" />
      <Container fluid="lg" className="py-md-6 py-5">
        <DynamicText path="carousel.jobs.title" tag="h2">
          {title}
        </DynamicText>
        <Carousel
          className={classes.jobs__carousel}
          indicators={false}
          controls={true}
          visibleCount={visibleCount}
          items={jobs.map((i) => (
            <JobCard className="h-100 p-lg-5" key={i.id} {...i} />
          ))}
        />
        <Stack className="flex-row justify-content-center">
          <Button variant="link" href={getRoute("jobs")}>
            See all
          </Button>
        </Stack>
      </Container>
    </div>
  );
};

export default JobsCarousel;
